export enum EntryType {
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
    BOOLEAN = 'BOOLEAN',
}
